module.exports = __webpack_public_path__ + "img/icon6.9e064ce6.png";